import {FiPlus} from "react-icons/fi";
import {Link, useLocation} from "react-router";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {GQL_RUM_LIST} from "@/lib/queries/rum.ts";
import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {QUERY} from "@/pages/checks/constants.ts";

export const RUMListActionsBar = () => {
  const location = useLocation();

  return (
    <div className="d-flex">
      <Button
        size={"large"}
        as={Link}
        state={{
          refetchQueries: [GQL_RUM_LIST],
          from: location,
        }}
        to={`/checks/create?${QUERY.MONITORING_SERVICE_TYPE}=${MonitoringServiceType.RUM2}`}
      >
        <Icon icon={FiPlus} /> Create RUM Check
      </Button>
    </div>
  );
};
